import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  phoneNumber: string;
  verificationId: string;
  isLoading: boolean;
  error: string | null;
  language?: string;
}

const initialState: AuthState = {
  phoneNumber: '',
  verificationId: '',
  isLoading: false,
  error: null,
  language: 'en',
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setStoredPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
    setVerificationId: (state, action: PayloadAction<string>) => {
      state.verificationId = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    clearAuthData: (state) => {
      state.phoneNumber = '';
      state.verificationId = '';
      state.error = null;
      state.language = 'en';
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setStoredPhoneNumber, setVerificationId, setLanguage, clearAuthData, clearError } = authSlice.actions;
export default authSlice.reducer;
